// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"349":"ff514794","355":"ff514794","381":"ff514794","384":"a89d67d0","409":"a89d67d0","659":"ff514794","840":"ff514794","853":"ff514794","971":"ff514794"}[chunkId] + ".chunk.css";
};